<template>
  <el-row class="dormitory-log-main">
    <el-tabs v-model="activeName"
             type="card"
             @tab-click="handleClick">
      <el-tab-pane label="今日记录"
                   name="today"></el-tab-pane>
      <el-tab-pane label="历史记录"
                   name="history"></el-tab-pane>
    </el-tabs>
    <el-card shadow="none"
             class="form-card mb-15">
      <el-form :inline="true"
               :model="searchForm"
               ref="search_form"
               class="search-form">
        <el-form-item label="姓名:"
                      prop="person_name">
          <el-input v-model.trim="searchForm.person_name"
                    placeholder="姓名"></el-input>
        </el-form-item>
        <el-form-item label="房间名:"
                      prop="room_name">
          <el-input v-model.trim="searchForm.room_name"
                    placeholder="房间名"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     @click="searchSubmit('search_form')">查询
          </el-button>
          <el-button icon="el-icon-refresh"
                     @click="resetForm('search_form')">重置
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="none"
             class="mt-15">
      <el-table max-height="575"
                ref="multipleTable"
                :data="tableData">
        <el-table-column type="index"
                         label="序号"
                         width="60"></el-table-column>
        <el-table-column v-for="(item, index) in tableTitle"
                         :key="index"
                         :label="item.name"
                         :prop="item.prop"
                         :min-width="item.width"
                         :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column v-if="activeName === 'history'"
                         label="登记日期"
                         prop="book_date"
                         min-width="120"
                         :show-overflow-tooltip="true">
        </el-table-column>
      </el-table>
      <Pagination :total="pagination.total"
                  :pageSize="pagination.perPage"
                  @handleSizeChange="handleSizeChange"
                  @handleCurrent="handleCurrentChange"></Pagination>
    </el-card>
  </el-row>
</template>

<script>
import fetch from '@/common/api'
import Pagination from '@/components/pagination/Pagination'
export default {
  components: { Pagination },
  data() {
    return {
      activeName: 'today',
      searchForm: {
        person_name: '',
        room_name: ''
      },
      tableTitle: [
        {
          prop: 'person_name',
          name: '人员姓名',
          width: '100'
        },
        {
          prop: 'person_no',
          name: '人员编号',
          width: '100'
        },
        {
          prop: 'room_name',
          name: '房间',
          width: '120'
        },
        {
          prop: 'back_person',
          name: '紧急联系人',
          width: '100'
        },
        {
          prop: 'back_ctx',
          name: '紧急联系方式',
          width: '120'
        },
        {
          prop: 'return_time',
          name: '归寝时间',
          width: '120'
        }
      ],
      tableData: [],
      // 分页相关
      pagination: {
        total: 0,
        currentPage: 1,
        perPage: 10
      },
      // 选中数据
      multipleSelection: [],
      // 添加维修相关
      showRepairModal: false,
      repairData: {
        type: 'add'
      },
      // 维修记录相关
      showDealModal: false,
      dealData: {
        id: -1
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取列表
    getList() {
      const { perPage, currentPage } = this.pagination
      fetch
        .getPersonReturnList({
          type: this.activeName,
          perPage: perPage,
          currentPage: currentPage,
          ...this.searchForm
        })
        .then((data) => {
          data.procData(
            data.res,
            (data) => {
              this.pagination.total = Number(data.total)
              this.tableData = data.list
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
    },
    handleClick() {
      this.getList()
    },
    // 搜索提交
    searchSubmit() {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.getList()
    },
    resetForm(formName) {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.$refs[formName].resetFields()
      this.getList()
    },
    // 分页
    handleSizeChange(val) {
      this.pagination.perPage = val
      this.pagination.currentPage = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getList()
    }
  }
}
</script>

<style lang="less">
.dormitory-log-main {
  .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    background: #fff;
    border-bottom-color: #409eff;
  }
}
</style>
